<template>
	404 页面不存在
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
</style>
